export default __webpack_public_path__ + "static/aluminijum-5db4dac92e93c9073fb7075b2a27d2e9.jpg";